import clsx from "clsx";

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Mono = 'mono',
  Ghost = 'ghost',
  Destructive = 'destructive',
  DesctructiveGhost = 'destructiveGhost'
}

const classForVariant = (variant?: ButtonVariant) => {
  switch (variant) {
    default:
      return 'bg-white border-primary-std text-primary-std hover:bg-primary-std font-medium';
    case ButtonVariant.Mono:
      return 'bg-white border-gray-200 text-primary-std hover:bg-primary-std font-medium';
    case ButtonVariant.Primary:
      return 'bg-primary-700 font-medium border-primary-700 text-white hover:brightness-95';
    case ButtonVariant.Ghost:
      return 'border-0 hover:bg-accent hover:text-accent-foreground';
    case ButtonVariant.Destructive:
      return 'border-red-500 bg-red-50 hover:bg-accent text-red-500 font-medium hover:text-red-300';
    case ButtonVariant.DesctructiveGhost:
      return 'border-0 hover:bg-accent hover:text-red-300 text-red-500 font-medium hover:bg-red-50';
    case ButtonVariant.Secondary:
      return 'bg-secondary-600 font-medium border-secondary-600 text-white hover:brightness-95';
    case ButtonVariant.Tertiary:
      return '';
  }
};

export const buttonClassName = (variant?: ButtonVariant) => {
  return clsx(
    'relative flex items-center justify-center gap-1 overflow-clip rounded-lg border py-1.5 px-3 text-sm disabled:opacity-40 disabled:pointer-events-none',
    classForVariant(variant)
  );
};
